export default __webpack_public_path__ + "static/media/bracelet.3de20667.webp";